(() => {
  const category = new URLSearchParams(window.location.search).get('category');
  const fields = { packaging: 'quote-packaging', design: 'quote-design', print: 'quote-print', qr: 'quote-qr', other: 'quote-other' };
  if (!Object.prototype.hasOwnProperty.call(fields, category)) return;
  const selected = document.getElementById(fields[category]);
  if (selected && !document.querySelector('.quote-category-input:checked')) {
    selected.checked = true;
    selected.dispatchEvent(new Event('change', { bubbles: true }));
  }
})();
